import { Group } from "@mantine/core"
import { Button } from "@tfg/ui"

import { IconRightArrow } from "~/components/icons/IconRightArrow"

type LoginButtonProps = {
  loading?: boolean
  disabled?: boolean
  onClick?: () => void
  type?: "button" | "submit" | "reset"
  children: React.ReactNode
}

export const LoginButton = ({
  loading,
  disabled,
  onClick,
  type = "button",
  children,
}: LoginButtonProps) => {
  return (
    <Button
      variant="primary"
      fullWidth={true}
      loading={loading}
      disabled={disabled}
      type={type}
      fz="sm"
      fw={700}
      ta="left"
      tt="uppercase"
      justify="flex-start"
      styles={{
        label: {
          width: "100%",
        },
      }}
      style={{
        borderRadius: "60px",
      }}
      size="md"
      onClick={onClick}
    >
      <Group
        justify="space-between"
        w="100%"
        align="center"
        gap="var(--mantine-spacing-xs)"
      >
        {children}
        <IconRightArrow />
      </Group>
    </Button>
  )
}
